import React, { useState, useMemo } from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { TableInstitutions } from './table-institutions';
import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import { useQuery } from 'jsonapi-react';
import { Card, CardBody, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TableRegionals } from './table-regionals';
import { Filter, FilterContent, FilterTitle } from '@/components/custom/filter';
import { IconWrapper } from '@/components/custom/icon';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';

export function WeekChallengeRankingByRegion() {
  const [showRegional, setShowRegional] = useState(false);
  const [selectedRegional, setSelectedRegional] = useState(null);
  const [sortDirection, setSortDirection] = useState('desc');

  const { data: regionals, isLoading } = useQuery('/challenges/ranking');
  const { data: institutions, isLoading: loadingInstitutions, error: errorInstitutions } = useQuery(selectedRegional ? `/challenges/ranking?filter[regional_id]=${selectedRegional.id}` : null);

  const ordenedRegionals = useMemo(
    () =>
      regionals?.data
        ?.filter(item => item.name !== 'Sem Vinculo' && item.name !== 'Já sou formado' && item.name !== 'Sem escola')
        ?.sort((a, b) => {
          if (sortDirection === 'asc') {
            return a.score - b.score;
          }
          if (sortDirection === 'desc') {
            return b.score - a.score;
          }
        }),
    [regionals]
  );

  const handleSelectRegional = regional => {
    setShowRegional(true);
    setSelectedRegional(regional);
  };

  if (isLoading) return <Loader />;

  if (ordenedRegionals.length === 0)
    return (
      <EmptyState
        type="data"
        title="Nenhum Ranking"
        text="Ainda não temos dados para mostrar"
      />
    );

  return (
    <Card
      hover={false}
      border={false}
    >
      <CardHeader>
        <CardTitle>Ranking</CardTitle>

        {showRegional && (
          <Filter>
            <FilterContent>
              <ButtonBack
                disabled
                onClick={() => setShowRegional(false)}
              >
                <ButtonBackContent>
                  <FilterTitle>GREs</FilterTitle>
                </ButtonBackContent>
              </ButtonBack>
              <ButtonBack onClick={() => setShowRegional(false)}>
                <IconWrapper>
                  <FiChevronLeft />
                </IconWrapper>
                <ButtonBackContent>
                  <FilterTitle>{selectedRegional?.name}</FilterTitle>
                </ButtonBackContent>
              </ButtonBack>
            </FilterContent>
          </Filter>
        )}
      </CardHeader>

      <CardContent>
        <CardBody>
          {!showRegional ? (
            <TableRegionals
              ordenedRegionals={ordenedRegionals}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              onSelectRegional={handleSelectRegional}
            />
          ) : (
            <TableInstitutions
              institutions={institutions?.data}
              loading={loadingInstitutions}
              error={errorInstitutions}
            />
          )}
        </CardBody>
      </CardContent>
    </Card>
  );
}
